/* unplugin-vue-components disabled */import { render } from "./Tailoring.vue?vue&type=template&id=185d8592&scoped=true"
import script from "./Tailoring.vue?vue&type=script&lang=js"
export * from "./Tailoring.vue?vue&type=script&lang=js"

import "./Tailoring.vue?vue&type=style&index=0&id=185d8592&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-185d8592"]])

export default __exports__